import { createReducer } from '@reduxjs/toolkit';
import {
  saveAccommodationSearchFormValues,
  saveAccommodationSearchResults,
  saveCheckoutFormValues,
  saveJourneyFormValues,
  saveLuggageFormValues,
  saveOptionalExtrasFormValues,
  saveOriginalServiceFormValues,
  savePassengerFormValues,
  saveServiceFormValues,
  saveVehicleFormValues,
  setAccommodationCurrentProvider,
  setAccommodationCurrentRoom,
  setAccommodationCurrentTotalPrice,
  setBookingTenant,
  setFerryGrouping,
  setJourneyDates,
  setJourneys,
  setMetaFlow,
  setSegmentStop,
} from 'redux/actions/ui/sealink';

const validSteps = ['/ferry', '/accommodation', '/experiences', '/checkout'];
const { pathname } = window.location;
const stepPath = validSteps.find((step) => pathname.includes(step));
const savedFerryGrouping = ecom.redux_initial_state.sealink?.ferryGrouping;
const bookingTenant = ecom.redux_initial_state.sealink?.bookingTenant;
let ferryGrouping = [];

if (savedFerryGrouping) {
  ferryGrouping = [
    {
      values: savedFerryGrouping,
    },
  ];
}

export const initialState = {
  metaFlow: {
    currentStep: stepPath || '/',
  },
  bookingTenant,
  ferryGrouping,
  accommodationFlow: {},
  accommodationGrouping: [],
  experienceGrouping: [],
};

export default createReducer(initialState, {
  [setMetaFlow]: (state, action) => {
    state.metaFlow = action.payload;
  },
  [setFerryGrouping]: (state, action) => {
    state.ferryGrouping = action.payload;
  },
  [saveVehicleFormValues]: (state, action) => {
    const currentGroupingIndex = 0;
    const { takingVehicle } =
      state.ferryGrouping[currentGroupingIndex].values.journeyForm;
    state.ferryGrouping[currentGroupingIndex].values.vehicleForm = {
      takingVehicle,
      ...action.payload,
    };
  },
  [saveJourneyFormValues]: (state, action) => {
    const existingFerryGrouping = state.ferryGrouping[0]?.values || {};

    state.ferryGrouping = [
      {
        values: {
          ...existingFerryGrouping,
          journeyForm: action.payload,
        },
      },
    ];
  },
  [setJourneyDates]: (state, action) => {
    const currentGroupingIndex = 0;
    state.ferryGrouping[currentGroupingIndex].values.journeyForm.journeyDates =
      action.payload;
  },
  [setJourneys]: (state, action) => {
    const currentGroupingIndex = 0;
    state.ferryGrouping[currentGroupingIndex].values.journeyForm.journeys =
      action.payload;
  },
  [setSegmentStop]: (state, action) => {
    const currentGroupingIndex = 0;

    const { journeyIndex, segmentId, segmentStop } = action.payload;

    const journey =
      state.ferryGrouping[currentGroupingIndex].values.journeyForm.journeys[
        journeyIndex
      ];

    journey.segmentStops[segmentId] = segmentStop;
  },
  [savePassengerFormValues]: (state, action) => {
    const { groupingIndex, passengers } = action.payload;
    state.ferryGrouping[groupingIndex].values.passengerForm = { passengers };
  },
  [saveLuggageFormValues]: (state, action) => {
    const existingFerryGrouping = state.ferryGrouping[0]?.values || {};

    state.ferryGrouping = [
      {
        values: {
          ...existingFerryGrouping,
          luggageForm: action.payload,
        },
      },
    ];
  },
  [saveServiceFormValues]: (state, action) => {
    const currentGroupingIndex = 0;
    state.ferryGrouping[currentGroupingIndex].values.serviceForm =
      action.payload;
  },
  [saveCheckoutFormValues]: (state, action) => {
    if (!state.ferryGrouping[0]) {
      state.ferryGrouping = [{ values: {} }];
    }
    state.ferryGrouping[0].values.checkoutForm = action.payload;
  },

  /*
  Need to keep the original form data for service form, otherwise the page breaks if the user
  goes back to the service form with a booking without shuttle(no vehicle and no shuttle transport)
  */
  [saveOriginalServiceFormValues]: (state, action) => {
    const currentGrouping = state.ferryGrouping[0];

    if (currentGrouping) {
      currentGrouping.values.originalServiceForm = action.payload;
    }
  },
  [saveAccommodationSearchFormValues]: (state, action) => {
    state.accommodationFlow.searchParams = action.payload;
  },
  [saveAccommodationSearchResults]: (state, action) => {
    state.accommodationFlow.searchResults = action.payload;
  },
  [setAccommodationCurrentProvider]: (state, action) => {
    state.accommodationFlow.currentProvider = action.payload;
  },
  [setAccommodationCurrentRoom]: (state, action) => {
    state.accommodationFlow.currentRoom = action.payload;
  },
  [setAccommodationCurrentRoom]: (state, action) => {
    state.accommodationFlow.currentRoom = action.payload;
  },
  [setAccommodationCurrentTotalPrice]: (state, action) => {
    state.accommodationFlow.currentTotalPrice = action.payload;
  },
  [setBookingTenant]: (state, action) => {
    state.bookingTenant = action.payload;
  },
  [saveOptionalExtrasFormValues]: (state, action) => {
    state.ferryGrouping[0].values.optionalExtrasForm = action.payload;
  },
});
